import * as React from 'react';

import { ConfigContext } from '../components/edge-config-provider';

export const useEdgeConfig = () => {
  const edgeConfig = React.useContext(ConfigContext);

  if (edgeConfig === undefined) {
    throw new Error('"useEdgeConfig" hook must be used within a "EdgeConfigProvider"');
  }

  return edgeConfig;
};
